import { ReactNode } from 'react';
import { Box } from '@mui/material';
import SmallBrandBanner from './SmallBrandBanner';
import LargeBrandBanner from './LargeBrandBanner';

type AuthContainerProps = {
  children: ReactNode;
};

const AuthContainer = ({ children }: AuthContainerProps) => {
  return (
    <Box
      display="flex"
      height="100%"
      sx={(theme) => ({ backgroundColor: theme.palette.custom.white })}
    >
      <Box flex={1} height="100%" overflow="auto">
        <SmallBrandBanner />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          minHeight={{ xs: 'fit-content', md: '100%' }}
          height="fit-content"
        >
          {children}
        </Box>
      </Box>
      <Box
        flex={1}
        height="100%"
        display={{ xs: 'none', md: 'flex' }}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        sx={(theme) => ({
          backgroundColor: theme.palette.custom.yellowTan,
        })}
      >
        <LargeBrandBanner />
      </Box>
    </Box>
  );
};

export default AuthContainer;
